import { DefaultEditableActionItemContentCSS } from '../../../models';
import { titles } from '../../styles/colors';
import { IRichContentDocumentEditorProps, RichContentDocumentEditor } from '../richContent/RichContentDocumentEditor';
import { TextMessageValidElementsStringValue } from '../richContent/RichContentDocumentEditor/validElements';

export function TextCampaignEditor({
	styles,
	config: editorConfig,
	disablePasteRichText = true,
	...props
}: IRichContentDocumentEditorProps) {
	const config = {
		autoresizeToFitContent: true,
		contentRawCss: DefaultEditableActionItemContentCSS.replace('padding: 0;', 'padding: 2px;').replace(
			/color:[ ]?[#]?[a-z0-9]*;/i,
			`color: ${titles};`
		),
		minHeight: 14,
		plugins: ['placeholders'],
		toolbar: false,
		useDefaultEmailPlaceholders: true,
		validElements: TextMessageValidElementsStringValue,
		...editorConfig,
	};

	return (
		<RichContentDocumentEditor config={config} disablePasteRichText={disablePasteRichText} styles={styles} {...props} />
	);
}
